import { useQuery } from "@tanstack/react-query"
import axios from "axios"
import { createContext, useContext } from "react"

const ProductsContext = createContext({})

export default function useProducts() {
  return useContext(ProductsContext)
}

export function ProductsContextProvider({ children }) {
  const { data, isLoading } = useQuery({
    queryKey: ["products"],
    queryFn: async () => {
      const res = await axios.get(process.env.REACT_APP_PRODUCTS_API)
      return res.data
    },
  })

  return (
    <ProductsContext.Provider
      value={{
        products: data?.products,
        isLoading,
      }}
    >
      {children}
    </ProductsContext.Provider>
  )
}
